var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check
import { Box, Label, Text } from '@bottlebooks/gatsby-design-system';
import { ErrorMessage, getIn, useFormikContext } from 'formik';
import { jsx } from 'theme-ui';
import useFormTheme from './useFormTheme';
export default function FieldLayout(_a) {
    var { name, label, description, children, ignoreErrors = false } = _a, rest = __rest(_a, ["name", "label", "description", "children", "ignoreErrors"]);
    const theme = useFormTheme();
    const { errors } = useFormikContext();
    const error = ignoreErrors ? '' : getIn(errors, name);
    return (jsx(Box, { as: "label", sx: Object.assign({ display: 'block' }, theme === null || theme === void 0 ? void 0 : theme.fieldLayout) },
        jsx(Label, { sx: theme === null || theme === void 0 ? void 0 : theme.label }, label),
        jsx(Box, { sx: theme === null || theme === void 0 ? void 0 : theme.field },
            children,
            !error && description && (jsx(Text, { variant: "smallest", sx: { color: 'lightText' } }, description)),
            error && (
            // @ts-ignore
            jsx(ErrorMessage, { name: name, 
                // @ts-ignore This *is* a component, but doesn't match string | React.ComponentType for some reason.
                component: Text, 
                // @ts-ignore variant will be passed to the Text component.
                variant: "smallest", sx: Object.assign({ color: 'brand.warningRed' }, theme === null || theme === void 0 ? void 0 : theme.error) })))));
}
//# sourceMappingURL=FieldLayout.js.map